// purehealthnexus/src/components/payments/CheckoutCancel.jsx
import React from "react";
export default function CheckoutCancel() {
  return (
    <div style={{maxWidth:720,margin:"40px auto",padding:"0 16px"}}>
      <h2>Checkout Canceled</h2>
      <p>No charges were made. You can try again anytime.</p>
      <a className="btn" href="/checkout" style={{display:"inline-block",marginTop:16}}>Return to Checkout</a>
    </div>
  );
}
